import { Component } from '@angular/core';
import { BehaviorSubject, combineLatest, switchMap } from 'rxjs';

import { MonitoringService } from '@core/services/monitoring.service';
import { ContactType } from '@features/contacts/models/contactType';
import { ReportAbstract } from '@features/reports/abstracts/report.abstract';
import { ReportsService } from '@features/reports/services/reports.service';
import { PageRequest } from '@shared/components/data-table/models/page-request';
import { Report } from '@shared/enums/report.enum';

interface ContactSummary {
  type: ContactType;
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  mobile: string;
  email: string;
  dob: string;
}

@Component({
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsReportComponent extends ReportAbstract<ContactSummary> {
  title = 'Contacts';
  reportName = Report.Contacts;
  columns = [
    { name: 'Type' },
    { name: 'Name' },
    { name: 'Mobile', prop: 'mobile' },
    { name: 'Email', prop: 'email' },
    { name: 'Dob', prop: 'dob' }
  ];
  csvHeaders = [
    {
      label: 'Contact Type',
      value: 'clientContactType'
    },
    {
      label: 'Name',
      value: 'clientName'
    },
    {
      label: 'Event Type',
      value: 'clientEventType'
    },
    {
      label: 'Status',
      value: 'clientStatus'
    },
    {
      label: 'Title',
      value: 'title'
    },
    {
      label: 'First name',
      value: 'firstName'
    },
    {
      label: 'Last name',
      value: 'lastName'
    },
    {
      label: 'Email',
      value: 'clientEmail'
    },
    {
      label: 'Mobile',
      value: 'clientMobile'
    },
    {
      label: 'Date of Birth',
      value: 'dateOfBirth'
    },
    {
      label: 'Discriminator',
      value: 'discriminator'
    },
    {
      label: 'Id',
      value: 'clientId'
    },
    {
      label: 'Address',
      value: 'clientAddress'
    },
    {
      label: 'Created Date',
      value: 'clientCreatedDate'
    },
    {
      label: 'PAYG Income',
      value: 'incomePayg'
    },
    {
      label: 'Self Employed Income',
      value: 'incomeSelfEmployed'
    },
    {
      label: 'Government Agency Income',
      value: 'incomeGovernmentAgency'
    },
    {
      label: 'Super Income',
      value: 'incomeSuper'
    },
    {
      label: 'Other Income',
      value: 'incomeOther'
    },
    {
      label: 'EDM Unsubscribed',
      value: 'edmUnsubscribedDate'
    },
    {
      label: 'EDM Bounce Reason',
      value: 'edmBounceReason'
    }
  ];

  constructor(
    reportsService: ReportsService,
    monitoringService: MonitoringService
  ) {
    super(Report.Contacts, reportsService, monitoringService);
  }
}
